export const SET_LOADING_DATA = '@team/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@team/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@team/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@team/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@team/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@team/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@team/SAVE_REQUEST';
export const SAVE_SUCCESS = '@team/SAVE_SUCCESS';

export const DELETE_ITEM = '@team/DELETE_ITEM';
export const EDIT_ITEM = '@team/EDIT_ITEM';

export const SEARCH = '@team/SEARCH';

export const SET_PAGE = '@team/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@team/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@team/SET_ORDER';
export const SET_ORDERBY = '@team/SET_ORDEBY';
